import { getToken } from "../../../../utils/utils";
import axios from "axios";
import { ENDPOINT } from "../../../../constants/endpointConstants";
import BarChart from "../../../../components/BarChart/BarChart";
import { getRangeDates, formatDateTime } from "../../../../utils/utils";
import { useState, useEffect, useCallback } from "react";

export const InsightTopProductCategories = ({ startDate, endDate }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const chartOptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        title: {
          display: true,
          text: "Cantidad Ventas",
        },
        beginAtZero: true,
      },
    },
  };

  const getTopCategoriesData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const token = getToken();
      const [dateInitFormatted, dateFinishFormatted] = getRangeDates(
        startDate,
        endDate
      );
      const requestBody = {
        startDate: formatDateTime(dateInitFormatted),
        endDate: formatDateTime(dateFinishFormatted),
      };

      const { data } = await axios.post(
        ENDPOINT.POST_TOP_CATEGORIES,
        requestBody,
        token
      );
      const colors = ["#ffbe73", "#4bc0c0"];
      const chartData = {
        labels: data.topCategories.map((category) => category.categoryName),
        datasets: [
          {
            label: "Ventas",
            data: data.topCategories.map((category) => category.totalAmount),
            backgroundColor: data.topCategories.map(
              (_, index) => colors[index % colors.length]
            ),
          },
        ],
      };
      setData(chartData);
    } catch (error) {
      console.error("Error fetching top categories data:", error);
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (startDate && endDate) {
      getTopCategoriesData();
    }
  }, [startDate, endDate, getTopCategoriesData]);

  return (
    <div>
      {loading && <div>Cargando...</div>}
      {error && <div>Error</div>}
      {data && (
        <BarChart data={data} options={chartOptions} showDataLabels={true} />
      )}
    </div>
  );
};
export default InsightTopProductCategories;
